import React from 'react';
import { Box, Grid, Typography, useTheme } from '@mui/material';
import UseCurrency from '@shared/hooks/UseCurrency';

import CarrierInfo from './RatesParts/CarrierInfo';
import FlightTimes from './RatesParts/FlightTimes';

import {
  findScale,
  flightTimeConvert,
  returnTime,
} from '@shared/helpers/flights/flights';

import TaxesTooltip from '@FlightsComponents/TaxesTooltip';
import NumberOfPassengers from './RatesParts/NumberOfPassengers';

import { sxStyled } from './styles';

const FlightCard = ({
  object_cluster = {},
  children,
  flightsInUSD,
  common_title,
  activeRadio,
  isCustomSearch,
  passengers,
}) => {
  const theme = useTheme();
  const sxStyle = sxStyled(theme);

  const { currency } = UseCurrency();

  const {
    composition_price = {},
    carrier,
    fare_supplier,
    source,
  } = object_cluster;

  const {
    total_taxes,
    tax_detail = {},
    country_tax,
    taxQ1_name,
    inf_price,
    cnn_price,
    adt_price,
    total_charges,
    taxQ1,
    total,
  } = composition_price;

  const { adults, childs, childsBaby } = passengers;

  const hasTaxes = total_taxes > 0;

  return (
    <>
      <CarrierInfo
        isCustomSearch={isCustomSearch}
        carrier={carrier}
        common_title={common_title}
        activeRadio={activeRadio}
        fare_supplier={fare_supplier}
        source={source}
      />

      <FlightTimes
        isCustomSearch={isCustomSearch}
        common_title={common_title}
        activeRadio={activeRadio}
        returnTime={returnTime}
        findScale={findScale}
        flightTimeConvert={flightTimeConvert}
      />

      <Box>
        <Grid container>
          <Grid item xs={6}>
            <NumberOfPassengers
              adults={adults}
              childs={childs}
              childsBaby={childsBaby}
            />

            <TaxesTooltip
              tax_detail={tax_detail}
              formatValue={currency}
              disableHover={!hasTaxes}
            >
              <Typography sx={sxStyle.priceConcept}>Impuestos</Typography>
            </TaxesTooltip>

            {country_tax > 0 && flightsInUSD.isInARS ? (
              <Typography sx={sxStyle.priceConcept}>Imp. PAIS</Typography>
            ) : (
              ''
            )}
            {taxQ1 > 0 && flightsInUSD.isInARS ? (
              <Typography sx={sxStyle.priceConcept}>{taxQ1_name}</Typography>
            ) : (
              ''
            )}

            {total_charges > 0 && (
              <Typography sx={sxStyle.priceConcept}>Cargos</Typography>
            )}
          </Grid>

          <Grid item xs={6} sx={sxStyle.priceValueContainer}>
            <Typography sx={sxStyle.priceValue}>
              {currency(adt_price)}
            </Typography>

            {childs > 0 && (
              <Typography sx={sxStyle.priceValue}>
                {cnn_price > 0 ? currency(cnn_price) : 'Sin Cargo'}
              </Typography>
            )}

            {childsBaby > 0 && (
              <Typography sx={sxStyle.priceValue}>
                {inf_price > 0 ? currency(inf_price) : 'Sin Cargo'}
              </Typography>
            )}

            <Typography sx={sxStyle.priceValue}>
              {hasTaxes ? currency(total_taxes) : 'Consultar'}
            </Typography>

            {country_tax > 0 && flightsInUSD.isInARS ? (
              <Typography sx={sxStyle.priceValue}>
                {currency(country_tax)}
              </Typography>
            ) : (
              ''
            )}

            {taxQ1 > 0 && flightsInUSD.isInARS ? (
              <Typography sx={sxStyle.priceValue}>{currency(taxQ1)}</Typography>
            ) : (
              ''
            )}

            {total_charges > 0 && (
              <Typography sx={sxStyle.priceValue}>
                {currency(total_charges)}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Box>
      <Grid container>
        <Grid item xs={12}>
          <Box sx={sxStyle.separatorHorizontal} />
        </Grid>
      </Grid>
      <Box>
        <Grid container>
          <Grid item xs={3}>
            <Typography sx={sxStyle.total}>Total:</Typography>
          </Grid>
          <Grid item xs={9}>
            <Typography sx={sxStyle.totalPrice}>{currency(total)}</Typography>
          </Grid>
        </Grid>
      </Box>
      <Box
        id="BOXFLIGHTCARD"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          rowGap: '8px',
          width: '100%',
          marginTop: '20px',
        }}
      >
        {React.Children.map(children, child => (
          <Box sx={{ width: '100%', textAlign: 'center' }}>{child}</Box>
        ))}
      </Box>
    </>
  );
};

export default FlightCard;
